<template>
  <div id="tab4">
    <h1>Tab 4</h1>
    <p>Example tab menu 4 case is long name design system test.</p>
  </div>
</template>

<script>
export default {
  name: 'Tab4'
}
</script>